const ADMIN_PRIORITY = 1

export function isAdmin(priority: number): boolean {
  return priority <= ADMIN_PRIORITY
}

export function canApproveRequest(priority: number): boolean {
  return priority <= ADMIN_PRIORITY
}

export function canEditRequest(priority: number, stage?: number): boolean {
  return priority <= ADMIN_PRIORITY || stage === 1
}

export function canCancelRequest(priority: number, stage?: number): boolean {
  return priority <= ADMIN_PRIORITY || stage === 1
}

export function canGeneratePayroll(priority: number): boolean {
  return priority <= ADMIN_PRIORITY
}
